import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { ChancenwerkUser } from '@chancenwerk/master-data-management/users/entities/ChancenwerkUser.js';
import { DateTime } from 'luxon';

@Entity()
export class Comment extends MongoEntity {
  static override _class = 'Comment';
  static override _collectionName = 'comments';

  @Field(type => DateTime)
  createdAt: Maybe<DateTime>;

  @Field(type => String)
  userID: Maybe<string>;

  @DataLoadedField(type => ChancenwerkUser, ({ userID }) => userID)
  user: Maybe<ChancenwerkUser>;

  @Field(type => String)
  roomID: Maybe<string>;

  @Field(type => String)
  text: Maybe<string>;
}
